// frontend/src/components/Loader.js
import React from 'react';
import './Loader.css';

function Loader() {
  return (
    <div className="loader-overlay">
      <div className="bg-gradient"></div>
      
      <div className="loader-container">
        <div className="loader">
          <div className="ring"></div>
          <div className="ring"></div>
          <div className="ring"></div>
          <div className="orb"></div>
        </div>
        
        <div className="loading-text">PROCESSING</div>
        
        <div className="status-text">Please wait...</div>
      </div>
    </div>
  );
}

export default Loader;